import { render } from "./ProjetosPage.vue?vue&type=template&id=2829208f&scoped=true"
import script from "./ProjetosPage.vue?vue&type=script&lang=js"
export * from "./ProjetosPage.vue?vue&type=script&lang=js"

import "./ProjetosPage.vue?vue&type=style&index=0&id=2829208f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2829208f"]])

export default __exports__